module.exports = __webpack_public_path__ + "img/headphones.5fb8aa26.svg";